import React from 'react';
import P from 'prop-types';
import styled, { css } from 'styled-components';
import Button from 'components/Button/';

const MfaLockout = (props) => {
  const { onRequestClose, hoursLeft } = props;
  const hoursText = hoursLeft && hoursLeft > 0 ? `Please try again after ${hoursLeft} hours` : 'Please try again later';

  return (
    <Wrapper>
      <StyledHeading>Verification code limit reached</StyledHeading>
      <StyledContent>
        We limit users to receiving five verification code SMS messages in 24
        hours. You have reached this limit.
        <br />
        <br />
        {hoursText}, or{' '}
        <a href="mailto:hello@becollective.com">contact us </a>for support.
      </StyledContent>

      <StyledButtons>
        <Button
          variant="primary"
          fluid
          onClick={() => {
            onRequestClose();
          }}
        >
          Okay
        </Button>
      </StyledButtons>
    </Wrapper>
  );
};

const Wrapper = styled.div(
  ({ theme: { colors } }) => css`
    padding: 20px 30px;
    border-radius: 4px;
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
    background-color: #f7f7f7;
    margin-top: 50px;
    font-size: 14px;
    width: 528px;
    a {
      text-decoration: underline;
      cursor: pointer;
      color: ${colors.emperor};

      &:hover {
        font-weight: 900;
      }
    }
  `,
);

const StyledHeading = styled.div`
  font-style: normal;
  font-size: 25px;
  line-height: 34px;
  margin-bottom: 20px;
  margin-top: 16px;
`;
const StyledContent = styled.p`
  font-size: 14px;
  line-height: 19px;
`;

const StyledButtons = styled.div`
  display: flex;

  button {
    width: 160px;
    height: 40px;
    font-size: 14px;
    line-height: 19px;
    min-width: auto !important;
    margin-right: 10px;
  }
`;

MfaLockout.propTypes = {
  onRequestClose: P.func.isRequired,
  hoursLeft: P.number.isRequired,
};

export default MfaLockout;
